module.exports = __webpack_public_path__ + "img/kf.9abe52cf.png";